<template>
  <div class="teaching-evaluate-apply-option"
       v-loading="loading"
       element-loading-text="数据加载中，请稍等...">
    <template v-if="optionInfo">
      <div class="main"
           v-loading="committing"
           element-loading-text="数据提交中，请稍等...">
        <div class="main-cont">
          <AppScrollbar style="height: 100%">
            <div class="option-main">
              <el-form size="mini"
                       label-width="90px"
                       label-suffix="：">
                <el-form-item label="选项显示">
                  <el-radio-group v-model="optionInfo.flagScoreMode">
                    <template v-if="optionInfo.modes">
                      <el-radio v-for="mode in optionInfo.modes"
                                :key="mode.code"
                                :label="mode.code">{{mode.name}}</el-radio>
                    </template>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="选项内容">
                  <DataGrid size="mini"
                            border="none"
                            :data="optionInfo.items">
                    <DataGridColumn title="选项名称"
                                    align="center">
                      <template #default="{row}">
                        <el-input v-model="row.label"
                                  size="mini"
                                  type="text"
                                  maxlength="20"></el-input>
                      </template>
                    </DataGridColumn>
                    <DataGridColumn title="选项分值"
                                    width="100px"
                                    align="center">
                      <template #default="{row}">
                        <el-input-number v-model="row.score"
                                         controls-position="right"
                                         :min="1"
                                         :max="5"
                                         :precision="0"
                                         :step="1"></el-input-number>
                      </template>
                    </DataGridColumn>
                    <DataGridColumn title="星星等级数"
                                    width="140px"
                                    align="center">
                      <template #default="{row}">
                        <el-rate v-model="row.score"></el-rate>
                      </template>
                    </DataGridColumn>
                    <DataGridColumn title="操作"
                                    width="120px"
                                    align="center">
                      <template #default="{row}">
                        <el-button size="mini"
                                   type="text"
                                   @click="insertItem(row)">插入</el-button>
                        <el-divider direction="vertical"></el-divider>
                        <el-button size="mini"
                                   type="text"
                                   @click="deleteItem(row)">删除</el-button>
                      </template>
                    </DataGridColumn>
                    <template #empty>
                      <span class="empty-tip">未设置评教选项</span>
                    </template>
                  </DataGrid>
                </el-form-item>
                <el-form-item>
                  <div class="append">
                    <el-button size="mini"
                               type="text"
                               icon="el-icon-circle-plus"
                               :disabled="committing"
                               @click="addItem">添加评教选项</el-button>
                  </div>
                </el-form-item>
              </el-form>
            </div>
          </AppScrollbar>
        </div>
      </div>
      <div class="footer">
        <el-button size="mini"
                   type="primary"
                   :disabled="committing"
                   @click="handleApply">确认设置</el-button>
      </div>
    </template>
    <template v-else>
      <Hint v-if="!loading"
            type="error">
        <div>评教选项数据加载失败</div>
        <el-button type="text"
                   @click="loadOptionInfo">重新加载</el-button>
      </Hint>
    </template>
  </div>
</template>

<script>
import AppScrollbar from '../../../../../../../elements/AppScrollbar'
import DataGrid from '../../../../../../../elements/DataGrid'
import DataGridColumn from '../../../../../../../elements/DataGridColumn'
import Hint from '../../../../../../../elements/Hint'
import objectUtils from '../../../../../../../../util/objectUtils'
export default {
  name: 'TeachingEvaluateApplyOption',
  components: {
    AppScrollbar,
    DataGrid,
    DataGridColumn,
    Hint
  },
  props: {
    evaluation: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      loading: false,
      optionInfo: null,
      committing: false
    }
  },
  methods: {
    loadOptionInfo () {
      this.loading = true
      this.$ajax({
        url: '/workspace/manager/teaching/evaluate/apply/optionInfo',
        method: 'post',
        data: this.$qs.stringify({
          id: this.evaluation.id
        })
      }).then(response => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              this.optionInfo = response.data['optionInfo'] || {}
              break
            }
            default: {
              this.$message.warning(response.data['message'])
              break
            }
          }
        }
      }, () => {
        this.$message.error('请求发送失败，请稍后重试')
      }).finally(() => {
        this.loading = false
      })
    },
    addItem () {
      let optionInfo = this.optionInfo
      if (optionInfo) {
        let items = optionInfo.items || []
        items.push({})
        this.$set(optionInfo, 'items', items)
      }
    },
    insertItem (item) {
      let optionInfo = this.optionInfo
      if (optionInfo) {
        let items = optionInfo.items || []
        if (items) {
          let index = items.indexOf(item)
          if (index >= 0) {
            items.splice(index, 0, {})
          }
        }
      }
    },
    deleteItem (item) {
      let optionInfo = this.optionInfo
      if (optionInfo) {
        let items = optionInfo.items || []
        if (items) {
          let index = items.indexOf(item)
          if (index >= 0) {
            items.splice(index, 1)
          }
        }
      }
    },
    handleApply () {
      let optionInfo = this.optionInfo
      if (optionInfo) {
        if (!optionInfo.flagScoreMode) {
          this.$message.warning('请选择选项的显示形式')
          return
        }
        let items = optionInfo.items || []
        let isValid = items.every((item, index) => {
          if (!item.label) {
            this.$message.warning(`第${index + 1}项选项名称不能为空`)
            return
          }
          for (let i = 0; i < index; i++) {
            if (items[i].label === item.label) {
              this.$message.warning(`第${index + 1}项选项名称出现重复`)
              return
            }
          }
          if (!objectUtils.hasValue(item.score)) {
            this.$message.warning(`请设置第${index + 1}项分值`)
            return
          }
          return true
        })
        if (!isValid) {
          return
        }
        this.committing = true
        this.$ajax({
          url: '/workspace/manager/teaching/evaluate/apply/submitOptionInfo',
          method: 'post',
          data: this.$qs.stringify({
            id: this.evaluation.id,
            optionInfo: JSON.stringify(optionInfo)
          })
        }).then(response => {
          if (response.data) {
            switch (response.data['responseCode']) {
              case 'SUCCESS': {
                this.$message.success(response.data['message'])
                this.$nextTick(() => {
                  let items = response.data['items']
                  if (items) {
                    this.$set(optionInfo, 'items', items)
                  }
                })
                break
              }
              default: {
                this.$message.warning(response.data['message'])
                break
              }
            }
          }
        }, () => {
          this.$message.error('请求发送失败，请稍后重试')
        }).finally(() => {
          this.committing = false
        })
      }
    }
  },
  mounted () {
    this.loadOptionInfo()
  }
}
</script>

<style lang="scss">
  .teaching-evaluate-apply-option {
    height: 100%;
    display: flex;
    flex-direction: column;
    padding: 5px;
    box-sizing: border-box;
    & > .main {
      flex: auto;
      position: relative;
      & > .main-cont {
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        .option-main {
          margin: auto;
          width: 640px;
          max-width: 100%;
          padding: 10px 15px;
          .el-form {
            .el-form-item {
              .el-form-item__label {
                padding-left: 10px;
                font-size: 12px;
              }
              .el-form-item__content {
                .el-radio-group {
                  .el-radio__label {
                    font-size: 12px;
                  }
                }
                .vxe-table {
                  .vxe-table--header-wrapper {
                    margin-bottom: 10px;
                    .vxe-table--header {
                      .vxe-header--row {
                        background-color: #f9f9fa;
                      }
                    }
                  }
                  .vxe-table--body-wrapper {
                    .vxe-table--body {
                      .vxe-body--row {
                        .vxe-body--column {
                          position: relative;
                          height: 46px;
                          padding: 0;
                          .vxe-cell {
                            .el-input,
                            .el-input-number {
                              width: 100%;
                              .el-input__inner {
                                text-align: center;
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                  .vxe-table--empty-placeholder {
                    background-color: #fcfcfc;
                    .empty-tip {
                      font-size: 12px;
                    }
                  }
                }
                .append {
                  margin-top: -10px;
                  padding: 0 10px;
                }
              }
            }
          }
        }
      }
    }
    & > .footer {
      flex: none;
      text-align: center;
      padding: 9px 12px;
      background-color: #f9f9fa;
    }
  }
</style>
